import script from "./ConseillerUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ConseillerUser.vue?vue&type=script&setup=true&lang=js"

import "./ConseillerUser.vue?vue&type=style&index=0&id=6afdd254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afdd254"]])

export default __exports__